import { render } from "./apps.vue?vue&type=template&id=3aa319fe"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"

import "./apps.vue?vue&type=style&index=0&id=3aa319fe&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__